import { render, staticRenderFns } from "./CoverPicker.vue?vue&type=template&id=54cbebd6&scoped=true&"
import script from "./CoverPicker.vue?vue&type=script&lang=js&"
export * from "./CoverPicker.vue?vue&type=script&lang=js&"
import style0 from "./CoverPicker.vue?vue&type=style&index=0&id=54cbebd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbebd6",
  null
  
)

export default component.exports